export default __webpack_public_path__ + "static/media/Vector.ebb03f5f.svg";